import {Base} from "@/api/Base"

export class SalaryAdd extends Base {
    path = "salary/add"
}